import readingBook from 'assets/images/characters/CarolinaMariadeJesus/reading-a-book.webp';
import wavingHappily from 'assets/images/characters/CarolinaMariadeJesus/waving-happily.webp';
import Chat from 'containers/CompositionFeedback/Chat';
import {useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {getCompositionById} from 'store/reducers/compositions';
import {getLearningPath} from 'store/reducers/learningPath';
import {ApplicationState} from 'store/rootReducer';
import {timerSetup} from 'utils/functions/timer';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import {EventData} from 'utils/hooks/useTrackEvent/types';
import {CompositionDetailExtended} from 'utils/types/compositions';
import {LearningPathTemp} from 'utils/types/learningPath';
import styles from './GradesView.module.scss';
import RadioChipList, {RadioChips} from './RadioChipList';

interface StateProps {
  composition: ImmutableMap<CompositionDetailExtended>;
  learningPath?: LearningPathTemp;
}

export interface OwnProps {
  gradeList: RadioChips[];
  currentMessageList: string[];
}

export type GradesViewProps = OwnProps & StateProps;

function GradesView({
  gradeList,
  composition,
  learningPath,
  currentMessageList,
}: GradesViewProps): JSX.Element {
  const [selectedGrade, setSelectedGrade] = useState<string>();
  const {trackEvent} = useTrackEvent();
  const gradeTimer = useMemo(() => timerSetup(), []);

  const competence = gradeList.find((grade) => grade.name === selectedGrade);

  const eventData: EventData = {
    test: {
      test_id: composition.get('test_id'),
    },
    composition: {
      composition_id: Number(composition.get('id')),
    },
    review: {
      review_id: Number(composition.get('reviews')?.first()?.get('id') ?? 0),
    },
    learningPathInstance: {
      learning_path_instance_id: learningPath?.id ?? 0,
      learning_path_status: learningPath?.status ?? '',
    },
    competence: {
      competence_id: competence?.id ?? 0,
    },
  };

  function handleChoiceChange(event: React.ChangeEvent<HTMLInputElement>) {
    const gradeName = event.target.value;
    setSelectedGrade(gradeName);

    trackEvent('multigenre_time_spent_in_criteria_review', {
      ...eventData,
      time: {
        spent_time: gradeTimer.finish(),
      },
    });

    trackEvent('multigenre_clicked_on_criteria', {
      ...eventData,
      time: {
        spent_time: gradeTimer.finish(),
      },
      learningPathUserInstance: {
        learning_path_user_instance_id: Number(
          composition?.get('learning_path_user_instance_id') ?? 0,
        ),
        step_id: composition?.getIn(['step', 'id']) ?? 0,
      },
    });
  }

  function sendSawReviewEvent() {
    trackEvent('multigenre_seen_criteria_review', {
      ...eventData,
      learningPathUserInstance: {
        learning_path_user_instance_id: Number(
          composition?.get('learning_path_user_instance_id') ?? 0,
        ),
        step_id: composition?.getIn(['step', 'id']) ?? 0,
      },
    });
  }

  return (
    <>
      <section className={styles.wrapper}>
        <RadioChipList
          radioChipItemsList={gradeList}
          onChange={handleChoiceChange}
          selectedChipItem={selectedGrade}
        />

        <Chat
          messageList={currentMessageList}
          imageUrl={selectedGrade ? readingBook : wavingHappily}
          stacked
          variant="character-left"
          onChatEnd={sendSawReviewEvent}
        />
      </section>
    </>
  );
}

export default connect((state: ApplicationState) => ({
  composition: getCompositionById(state),
  learningPath: getLearningPath(state),
}))(GradesView);
